class DwilCampaign extends HTMLElement {
  static observedAttributes = ['data-start', 'data-end', 'hidden'];
  #timer;
  connectedCallback() {
    queueMicrotask(this.#update);
    document.addEventListener('visibilitychange', this.#update);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (this.isConnected && oldValue !== newValue) queueMicrotask(this.#update);
  }
  disconnectedCallback() {
    clearTimeout(this.#timer);
    document.removeEventListener('visibilitychange', this.#update);
  }
  #update = () => {
    clearTimeout(this.#timer);
    if (!this.isConnected) return;
    const start = Number(this.dataset.start) * 1000;
    const end = Number(this.dataset.end) * 1000;
    const now = Date.now();
    const active = Number.isFinite(start) && Number.isFinite(end) && start > 0 && end > start && now >= start && now < end;
    const content = this.querySelector('[data-campaign-content]');
    const fallback = this.querySelector('[data-campaign-fallback]');
    if (content) content.hidden = !active;
    if (fallback) fallback.hidden = active;
    if (!content && !fallback) this.hidden = !active;
    const next = start > now ? start : end > now ? end : 0;
    if (next) this.#timer = setTimeout(this.#update, Math.min(next - now + 20, 2147483647));
  };
}
if (!customElements.get('dwil-campaign')) customElements.define('dwil-campaign', DwilCampaign);
